// extracted by mini-css-extract-plugin
export default {"wrapper":"u9xul","large":"_4J7FE","small":"ipK9U","medium":"Xilz7","double":"wi1GF","triple":"zWiUS","quadruple":"y3QvP"};